import { Hidden, useStepperContext } from '@ahmdigital/ui';
import { includes } from 'lodash/fp';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { RootState } from '../../../../reducers';
import { STEPS } from '../../constants';
import { StepsWrapper } from './styles';
import ahmConstants from '../../../../ahm-constants';
import BuildYourCoverActions from '../../../../actions/build-your-cover';
import DesktopNavigation from './desktop-navigation';
import MobileExpandedNavigation from './mobile-expanded-navigation';
import MobileNavigation from './mobile-navigation';
import selectCustomer from '../../../../selectors/select-customer';
import useActiveIndex from '../../hooks/use-active-index';

const StyledDiv = styled.div`
  position: relative;
`;

type Props = {
  hasStepZero?: boolean;
};

const StepHeaderNavigation = ({ hasStepZero = false }: Props) => {
  const [isMobileNavExpanded, setIsMobileNavExpanded] = useState(false);
  const { activeStep, goToStep } = useStepperContext();
  const dispatch = useDispatch();
  const activeIndex = useActiveIndex();
  const hideForStepZero = hasStepZero && activeIndex === 0;
  const isFromRefinePrice =
    useSelector((state: RootState) => state.history[1]) === ahmConstants.URLS.SALES.REFINE_PRICE;
  const { hasRefinedPrice } = useSelector(selectCustomer);

  useEffect(() => {
    setIsMobileNavExpanded(false);
    window.scrollTo(0, 0);
  }, [activeStep]);

  useEffect(() => {
    if (isFromRefinePrice && hasRefinedPrice && includes(activeStep, [STEPS.SPLASH_SCREEN, STEPS.ABOUT_YOU])) {
      goToStep(STEPS.HOSPITAL_SERVICES);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFromRefinePrice]);

  useEffect(() => {
    BuildYourCoverActions.setActiveStep(activeStep)(dispatch);
  }, [activeStep, dispatch]);

  const handleGoToStep = (step: string) => {
    setIsMobileNavExpanded(false);
    BuildYourCoverActions.setActiveStep(step)(dispatch);
    goToStep(step);
  };

  if (hideForStepZero) {
    return null;
  }

  return (
    <StyledDiv>
      <StepsWrapper>
        <Hidden isBlock xs sm md>
          <DesktopNavigation handleGoToStep={handleGoToStep} hasStepZero={hasStepZero} />
        </Hidden>
        <Hidden isBlock lg xl df>
          <MobileNavigation
            hasStepZero={hasStepZero}
            isMobileNavExpanded={isMobileNavExpanded}
            setIsMobileNavExpanded={setIsMobileNavExpanded}
          />
        </Hidden>
      </StepsWrapper>
      <Hidden isBlock lg xl df>
        {isMobileNavExpanded && <MobileExpandedNavigation handleGoToStep={handleGoToStep} hasStepZero={hasStepZero} />}
      </Hidden>
    </StyledDiv>
  );
};

export default StepHeaderNavigation;
